export default {
  contact : {
    joinUs:"/JoinUs",
    doBusiness:"/DoBusinessWithUs"
  }
};
